import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the coin value
 *
 * @returns {object} the result data
 */
const getCoinValue = async () =>
  await fetchJSONData(
    `${constants.API_URL}/coin_price?${new URLSearchParams({
      symbol: 'POL'
    }).toString()}&network=${constants.NETWORK}`
  )

// Export
export default getCoinValue
